import { useEffect, useState } from 'react';

/** Маленький роутер на History API: админке хватает путей и query. */
const listeners = new Set<() => void>();

export function navigate(to: string, opts: { replace?: boolean } = {}): void {
  if (to === location.pathname + location.search) return;
  if (opts.replace) history.replaceState(null, '', to);
  else history.pushState(null, '', to);
  listeners.forEach((l) => l());
  window.scrollTo(0, 0);
}

export function useLocation(): { path: string; query: URLSearchParams } {
  const [, force] = useState(0);
  useEffect(() => {
    const l = () => force((n) => n + 1);
    listeners.add(l);
    window.addEventListener('popstate', l);
    return () => {
      listeners.delete(l);
      window.removeEventListener('popstate', l);
    };
  }, []);
  return { path: location.pathname, query: new URLSearchParams(location.search) };
}

/** Обновить query без новой записи в истории (фильтры). */
export function setQuery(params: Record<string, string | null | undefined>): void {
  const q = new URLSearchParams(location.search);
  for (const [k, v] of Object.entries(params)) {
    if (v === null || v === undefined || v === '') q.delete(k);
    else q.set(k, v);
  }
  const s = q.toString();
  navigate(`${location.pathname}${s ? `?${s}` : ''}`, { replace: true });
}

/** `/trends/:id` → { id }. */
export function match(pattern: string, path: string): Record<string, string> | null {
  const p = pattern.split('/');
  const a = path.replace(/\/$/, '').split('/');
  if (p.length !== a.length) return null;
  const out: Record<string, string> = {};
  for (let i = 0; i < p.length; i++) {
    if (p[i]!.startsWith(':')) out[p[i]!.slice(1)] = decodeURIComponent(a[i]!);
    else if (p[i] !== a[i]) return null;
  }
  return out;
}
